import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import PricingProvider, { usePricing } from '../../hooks/contexts/pricing-hooks';
import PricingTable from '../pricing';
import { getGoodLeapTpoPricing } from '../../dtos/goodleap';
import { useOffers } from '../../hooks/contexts/offers-hook';
import { getLightReachTpoPricing } from '../../dtos/lightreach';
import { CircularProgress } from "@material-ui/core";

/**
 * @callback onHideCallback
 * @callback setLoanAIdCallBack
 * 
 * @param {boolean} show Determines if the modal is loaded and shown
 * @param {onHideCallback} onHide Callback to hide the modal when closed
 * @param {setLoanAIdCallBack} setLoanAId Callback to update current loan based on id (mostly)
 * @param {Object} curLoan Current Selected Loan
 * @param {number} estimatedAnnualProduction Customers estimated annual power production
 * @param {number} systemSize Power size of customers system 
 * @param {number} batteryCost Cost of batteries else 0
 * @param {string} sfProjectId Sales Force ProjectId 
 * @returns {React.JSX.Element}
 */

function TPOProductsModal({
  setNeedToResyncTpoPricing,
  show,
  onHide,
  setLoanAId,
  curLoan,
  setPpw,
  pricingPayload, }) {

  const [radioValue, setRadioValue] = useState(curLoan.loanId);
  const { isLoading, offer, offers } = useOffers();
  const [ radioDisabled, setRadioDisabled ] = useState(true);

  useEffect(() => {
    setRadioDisabled(true);
  }, [offer]);

  const createLoanFromPricing = (pricing) => {
    return {
      loanId: null,
      loanName: offer.productCode === "LightReach PPA" 
        ? "LightReach PPA" 
        : offer.productCode === "PPAFixed" 
        ? "GoodLeap PPA" : "GoodLeap Lease",
      productId: offer.productCode === "LightReach PPA" ? pricing.productId : offer.productId,
      offerId: offer.id,
      itc: "0.0000",
      loanTerm: offer.term,
      option: offer.projectTypeName,
      loanInterest: "0.00",
      interestOnlyPayment: "0.0000000",
      isPpa: "1",
      dealerFee: 1.0,
      ppaEscalator: offer.productCode === "LightReach PPA" ? offer.escalatorRate : offer.escalatorRate / 100,
      ppaRate: pricing.productionRate?.value,
      ppwRate: pricing.pricePerUnit?.price,
      firstMonthPayment: pricing?.firstYearMonthlyBattery?.value ? pricing.firstYearMonthlyPayment?.value + pricing?.firstYearMonthlyBattery?.value : pricing.firstYearMonthlyPayment?.value,
      totalAmount: pricing.purchasePrice?.value,
      firstMonthBatteryPayment: pricing?.firstYearMonthlyBattery?.value
    };
  }

  const handleRadioChange = (value) => {
    setRadioDisabled(false);
    setRadioValue(value);
  }

  const handleSave = () => {
    // Removed this check because it was causing issues not updating when you select the same loan
    // if (radioValue !== curLoan.loanId && 
    //   (curLoan.offerId !== offer.id &&
    //     (curLoan.ppaEscalator !== radioValue.escalationRate) ||
    //     curLoan.ppaRate !== radioValue.productionRate.value ||
    //     curLoan.firstMonthPayment !== radioValue.firstYearMonthlyPayment?.value
    //   )) {
        const loan = createLoanFromPricing(radioValue)
        setPpw(loan.ppwRate, true);
        setLoanAId(loan);
    // }
    setNeedToResyncTpoPricing(false);
    onHide();
  };
  if (offer) {
    if (pricingPayload.provider?.toLowerCase()?.includes("goodleap"))
      pricingPayload.offerId = offer.id;
  }

  return isLoading || !offer ?
    <></>
    : (
    <PricingProvider >
      <TPOProductsModalContent
        show={show}
        onHide={onHide}
        offer={offer}
        handleRadioChange={handleRadioChange}
        curLoan={curLoan}
        pricingPayload={pricingPayload}
        radioDisabled={radioDisabled}
        handleSave={handleSave}
      />
    </PricingProvider>
  );
}

function TPOProductsModalContent({
  show,
  onHide,
  offer,
  handleRadioChange,
  curLoan,
  pricingPayload,
  radioDisabled,
  handleSave,
}) {
  const { warning } = usePricing();
  const isGoodLeap = pricingPayload.provider?.toLowerCase()?.includes("goodleap");

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{offer.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <PricingTable
            handleRadioChange={handleRadioChange}
            loan={curLoan}
            pricingPayload={pricingPayload}
            getPricingDTO={pricingPayload.provider?.toLowerCase()?.includes("goodleap") ? getGoodLeapTpoPricing : getLightReachTpoPricing}
            useBattery={pricingPayload.provider?.toLowerCase()?.includes("lightreach")}
            selectedEscRate={pricingPayload.provider?.toLowerCase()?.includes("goodleap") ? offer.escalatorRate : 0.99} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        {isGoodLeap && warning && (
          <div style={{ width: '100%', marginBottom: '10px' }}>
            <div style={{ color: 'red', textAlign: 'center' }}>
              {warning}
            </div>
          </div>
        )}
        <Button variant="secondary" onClick={onHide}>Close</Button>
        <Button variant="primary" disabled={radioDisabled} onClick={handleSave}>Save Changes</Button>
      </Modal.Footer>
    </Modal>
  );
}


export default TPOProductsModal;